import { memo, useState } from "react";
import MicrosoftLoginButton from "../../../SocialMediaAuthentication/components/MicrosoftLoginButton";
import Cookies from "universal-cookie";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest";
//@ts-ignore
import config from "config";
import ToastHtmlComponent from "../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent";
import FormValidationMessage from "../../../../Reusable/Form/FormValidationMessage.js";
import type { GlobalConfigT } from "../../../../../models/models.js";
import GoogleLoginButton from "../../../SocialMediaAuthentication/components/GoogleLoginButton.tsx";
import addRefererToBodyRequest from "helpers/addRefererToBodyRequest.ts";
import useCustomLoginErrorHandler from "hooks/useCustomLoginErrorHandler.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { useModal } from "../../../../../contexts/modalContext/modalContext";
import { useToasts } from "react-toast-notifications";
import { useUser } from "../../../../../contexts/userContext/userContext";

import styles from "./styles.module.scss";

type ErrorResponseT = {
  message: string;
  status: string;
};

interface LoginExternalServiceDeniedI {
  allowedLoginServices: ("microsoft" | "google" | "email")[];
}

const typedConfig = config as GlobalConfigT;

const cookies = new Cookies();

const LoginExternalServiceDenied = memo(
  (props: LoginExternalServiceDeniedI) => {
    const { allowedLoginServices } = props;
    const { getTextByKey, getPath, getCurrentPage } = useContent();
    const { closeModal } = useModal();
    const { addToast } = useToasts();
    const { setUser } = useUser();
    const [errorResponse, setErrorResponse] = useState<ErrorResponseT[] | null>(
      null
    );

    const handleCustomError = useCustomLoginErrorHandler();

    const handleApiAuth = async (body: any) => {
      addRefererToBodyRequest(body);

      const response = await apiRequest(
        "Users",
        "APIExternalLogin",
        body,
        "POST",
        null,
        "application/json",
        null,
        false,
        true
      );
      if (response.status === "success") {
        // Set auth token to cookies
        document.cookie =
          //@ts-ignore
          config.api.jumbomailApiAuthCookie +
          "=" +
          response.data?.BearerToken +
          ";path=/";

        cookies.set("loginDate", response.data.nowDate, {
          path: "/",
          domain: ".jumbomail.me",
        });

        setUser(response.data);
        if (response.data.IsRegistered) {
          window.location.href = typedConfig.baseurl + getPath();
        }
        addToast(getTextByKey("sign-in-success"), { appearance: "success" });

        if (
          getCurrentPage() === "registration" &&
          !response.data.IsRegistered
        ) {
          window.location.href = typedConfig.baseurl + getPath();
        }
        closeModal();

        return {
          callBack: closeModal,
          status: "success",
        };
      } else {
        if (
          response?.data?.includes("microsoft") ||
          response?.data?.includes("google") ||
          response?.data?.includes("sub-user-must-join-organization")
        ) {
          handleCustomError(response.data);
          return;
        }

        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", 1);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", typedConfig.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });

        setErrorResponse([
          {
            message: response.data,
            status: response.status,
          },
        ]);

        return {
          message: (response as unknown as { message: string }).message,
          status: response.status,
        };
      }
    };

    return (
      <div className={styles.loginExternalServiceDeniedWrapper}>
        <h1>{getTextByKey("account-access-restriction")}</h1>
        <p>
          {getTextByKey(
            "login-external-service-denied-" + allowedLoginServices.join("-")
          )}
        </p>
        <div className={styles.buttons}>
          {allowedLoginServices.includes("microsoft") ? (
            <MicrosoftLoginButton handleApiAuth={handleApiAuth} />
          ) : null}
          {allowedLoginServices.includes("google") ? (
            <GoogleLoginButton handleApiAuth={handleApiAuth} />
          ) : null}
        </div>
        {errorResponse && (
          <div className="external-login-error-container">
            <FormValidationMessage errorMessageObj={errorResponse} />
          </div>
        )}
      </div>
    );
  }
);

export default LoginExternalServiceDenied;
